import React from 'react';
import createThemedComponent from '../../../theming/utils/createThemedComponent';
import { InputStyles } from './Input.styles';
/**
 * Themeable HTML `input` with some default styling
 *
 * Takes in all of the same attributes as [HTML input elements](https://www.w3schools.com/tags/tag_input.asp)
 *
 * ```js
 * import { Input } from '@minerva-analytics/pantheon';
 * <Input placeholder="Input..." />
 * ```
 * **Default Styles**
 *
 * To view the component's styling directly, see [Input.styles.js](https://git.cogolo.net/minerva/pantheon/blob/master/src/components/elements/Input/Input.styles.js)
 *
 */

export var InputComponent = function InputComponent() {
  return /*#__PURE__*/React.createElement(InputStyles, null);
};
export var Input = createThemedComponent('Input', InputStyles);
export default Input;